<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="filterPageTable" style="width: 100%;">
      <thead class="filterPageTableHeadWithoutFilters">
        <tr class="row">
          <th
            *ngIf="options && options.showCheckbox"
            class="col xxsColCheckbox checkboxCol"
          >
            <div class="colCheckboxHeadContainer">
              <input
                type="checkbox"
                id="cbox1"
                value="checkbox"
                [checked]="checkedAll"
                (click)="selectElement('all')"
              />
            </div>
          </th>
          <th class="checkboxCol" *ngIf="options && options.arrowUpDown"></th>
          <th class="checkboxCol" *ngIf="options && options.arrowUpDown"></th>
          <th
            class="{{ item.labelHeader ? 'sorted' : '' }}  col {{ item.size }}"
            *ngFor="let item of tableList"
          >
            <ng-container *ngIf="item.labelHeader">
              <span *ngIf="options && options.label">{{
                item.labelHeader
              }}</span>
              <div class="colSorterContainer">
                <a
                  (click)="onChangeOrder(item.order, true)"
                  *ngIf="!item.hideOrderButton"
                >
                  <em
                    *ngIf="
                      options && options.orderColumns && item.labelHeader != ''
                    "
                    class="sortIcon fas fa-sort-up"
                  ></em>
                </a>
                <a
                  (click)="onChangeOrder(item.order, false)"
                  *ngIf="!item.hideOrderButton"
                >
                  <em
                    *ngIf="
                      options && options.orderColumns && item.labelHeader != ''
                    "
                    class="sortIcon fas fa-sort-down"
                  ></em>
                </a>
              </div>
            </ng-container>
          </th>
          <th class="col xsColButton" *ngIf="options && options.filtersButton">
            <div class="smallHeaderButtons">
              <div class="buttonContainer eraserContainer">
                <button
                  class="submitSearchButton"
                  (click)="headerButtonsAction('erase')"
                  type="button"
                >
                  <em class="fas fa-eraser"></em>
                </button>
              </div>

              <div class="buttonContainer searchContainer">
                <button
                  class="submitSearchButton"
                  (click)="headerButtonsAction('search')"
                  type="button"
                >
                  <em class="fa-search fas"></em>
                </button>
              </div>

              <div class="buttonContainer filterContainer">
                <button
                  class="submitSearchButton"
                  (click)="headerButtonsAction('toggleFilters')"
                  type="button"
                >
                  <em class="fas fa-filter"></em>
                </button>
              </div>
            </div>
          </th>
          <th
            class="col xsColButton"
            *ngIf="options && !options.hideEditButton && !options.filtersButton"
          >
            <!--Espacio para cuando no se quieren mostrar los botones de filtros pero si el de edicción, así se cuadra bien la tabla-->
          </th>
        </tr>
      </thead>

      <tbody id="modalTableBody" class="filterPageTableBody">
        <div class="trContainer">
          <ng-container *ngFor="let element of elementList; let i = index">
            <tr class=" backgroundblack row {{ i % 2 === 0 ? 'even' : 'odd' }}">
              <td
                *ngIf="options && options.showCheckbox"
                class="col xxsColCheckbox checkboxCol tableCheckbox"
              >
                <div class="colCheckboxContainer">
                  <input
                    type="checkbox"
                    id="cbox1"
                    value="checkbox"
                    [checked]="isChecked(element[routing.id])"
                    (click)="selectElement(element[routing.id])"
                  />
                </div>
              </td>
              <td
                *ngIf="options && options.arrowUpDown"
                class="col checkboxCol"
              >
                <button
                  class="arrowUpDown"
                  (click)="moveUp(element[routing.id])"
                  type="button"
                >
                  <em class="fas fa-arrow-up"></em>
                </button>
              </td>
              <td
                *ngIf="options && options.arrowUpDown"
                class="col checkboxCol"
              >
                <button
                  class="arrowUpDown"
                  (click)="moveDown(element[routing.id])"
                  type="button"
                >
                  <em class="fas fa-arrow-down"></em>
                </button>
              </td>
              <td
                *ngFor="let col of tableList"
                class="col genericElement {{ col.size }}"
                [ngClass]="col.download ? 'tableButtonContainer' : ''"
                [ngStyle]="{ display: col.labelHeader == '' ? 'none' : '' }"
              >
                <ng-container *ngIf="!col.special">
                  <div class="labelTextContainer">
                    <p>{{ element[col.objectKey] }}</p>
                  </div>
                </ng-container>
                <!-- Caso para botones especiales -->
                <ng-container *ngIf="col.download">
                  <button
                    (click)="download(element)"
                    class="buttonDownload adjustPosInTable"
                    type="button"
                  >
                    <em class="fas fa-file-download"> </em>
                  </button>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </div>
      </tbody>
    </table>
  </div>
</ng-template>
